import 'babel-polyfill';
import React from 'react';
import { Switch } from 'react-router-dom';
import './App.less';
import SimulantComputer from 'containers/computers/simulants';
import RecipeResult from 'containers/computers/result';
import Recipes from 'containers/computers/recipes';
import RecipeDetails from 'containers/computers/recipes/details';
import EditRecipe from 'containers/computers/recipes/edit/Edit';
import Specifications from 'containers/specifications';
import SpecificationDetails from 'containers/specifications/details';
import Proposal from 'containers/orders/proposals';
import Orders from 'containers/orders';
import AuthForm from 'containers/auth/form';
import AgentMainLayoutRoutes from '../../hoc/routes/AgentMainRoutes';
// import HomePage from '../home/Home';
import NotFoundPage from '../../pages/404';

const App = () => (
  <Switch>
    <AgentMainLayoutRoutes exact path="/" component={SimulantComputer} />
    <AgentMainLayoutRoutes exact path="/calculateur-simulant" component={SimulantComputer} />
    <AgentMainLayoutRoutes exact path="/recipe_result" component={RecipeResult} />
    <AgentMainLayoutRoutes exact path="/recipes" component={Recipes} />
    <AgentMainLayoutRoutes exact path="/recipe/:recipeId/details" component={RecipeDetails} />
    <AgentMainLayoutRoutes exact path="/recipe/:recipeId/edit" component={EditRecipe} />
    <AgentMainLayoutRoutes exact path="/specifications" component={Specifications} />
    <AgentMainLayoutRoutes exact path="/specification/:recipeId/:specificationId/details" component={SpecificationDetails} />
    <AgentMainLayoutRoutes exact path="/proposal" component={Proposal} />
    <AgentMainLayoutRoutes exact path="/orders" component={Orders} />
    <AgentMainLayoutRoutes exact path="/authForm" component={AuthForm} />
    <AgentMainLayoutRoutes path="*" component={NotFoundPage} />
  </Switch>
);

export default App;
